import { IAddTray } from '../../models/forms/IAddUpdateTray';
const initialTrayState: IAddTray = {
  TenantId: 0,
  TrayId: '',
  CustomerId: '',
  OrderId: '',
  ProductId: -1,
  Katashiki1: '',
  Kishu: '',
  EndUserOrderId: '',
  CustomerDueDate: '',
  MissingParts: '無',
  PlanedDueDate: '',
  Group: '',
  CurrentState: 'Pending',
  Remarks: '',
  EndUserName: '',
  SubContractor: '',
  SubContractorName: '',
  Katashiki2: '',
  ProcessName: '',
  Quantity: '',
  InvoiceNumber: '',
  QuantityUnitName: '',
  ProductComment1: '',
  ProductComment2: '',
  ProductComment3: '',
  ProductComment4: '',
  ProductComment5: '',
  ProductComment6: '',
  ProductName: ''
};

export default initialTrayState;
